export default "__VITE_ASSET__9n4nWzLK__"